export enum Storage {
  accessToken = "accessToken",
  auth = "auth",
}
